<script setup lang="ts">
import { ref } from 'vue';
import ImportantTerms from '@/components/ImportantTerms.vue';
import { useRouter } from 'vue-router';
import { useAuthUser } from '@/helpers/globals';
import { appUrl } from '@/helpers/api';
import { emit as emitGlobalEvent } from '@/composables/useGlobalEventBus';

const router = useRouter();
const loading = ref(false);

const user = useAuthUser();

function onNewGeschaeftClick() {
    if (!user) {
        // login (via AGOV dialog), then continue to the new geschaeft:
        emitGlobalEvent('login', appUrl(router.resolve({ name: 'planungsgeschaefte-create' }).fullPath));
        return;
    }
    router.push({ name: 'planungsgeschaefte-create' });
}
</script>
<template>
    <div class="cta-grid">
        <div>
            <h2 class="ktg-title-02 mb-2_5rem">{{ $t('overview') }}</h2>
            <p class="ktg-body-lead mb-5rem" v-html="$t('geschaeft_overview_info_text')"></p>
        </div>

        <div>
            <h4 class="ktg-title-04 mb-2_5rem">{{ $t('dienstleistungen') }}</h4>
            <h5 class="ktg-subtitle-02 mb-1_5rem">{{ $t('geschaefte') }}</h5>
            <ktg-action-list class="ktg-box-margin-left mb-5rem">
                <ktg-action-item
                    href="href"
                    :link-text="loading ? $t('bitte_warten') : $t('starten')"
                    :disabled="loading"
                    @click.prevent="onNewGeschaeftClick"
                >
                    {{ $t('create_new_geschaeft') }}
                </ktg-action-item>
                <RouterLink :to="{ name: 'planungsgeschaefte-my-geschaefte' }" custom v-slot="{ href }">
                    <ktg-action-item :href="href" :link-text="$t('starten')">
                        {{ $t('edit_existing_geschaeft') }}
                    </ktg-action-item>
                </RouterLink>
            </ktg-action-list>
            <ImportantTerms
                :path="['geschaefte', 'overview_faq']"
                :title="$t('fragen_und_antworten')"
                size="small"
            ></ImportantTerms>
        </div>
    </div>
</template>

<style scoped></style>
